"use client";

import styles from "./styles.module.css";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

export default function Loader() {
  const [loaded, setLoaded] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 700);
  }, [pathname]);

  return (
    <>
      {!loaded && (
        <div key={pathname} className={styles.container}>
          <div
            style={{
              animation: "zoom-in-zoom-out 2s ease-in-out infinite",
            }}
          >
            <Image
              width={220}
              height={220}
              priority={true}
              title="loader"
              src="/logo-labs-white.webp"
              alt="loader"
            />
          </div>
        </div>
      )}
    </>
  );
}
